module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_13.0e0d1795.png";